/* nrt-hide-zero-filters — runs on collection/search pages, hides
   filter rows with count = 0 (Shopify's facet UI renders them anyway).
   Re-runs on facet update via MutationObserver. */
(function () {
  function hideZeros(root) {
    var scope = root || document;
    // Each Shopify facet item is typically <li> or <label> with the count
    // surfaced as the trailing token. Pull rows that wrap a checkbox + value.
    var rows = scope.querySelectorAll(
      'li.facets__item, .facets__item, label.facet-checkbox, .facet-checkbox-list__item, .filter-group__list-item'
    );
    rows.forEach(function (row) {
      var t = (row.textContent || '').trim();
      // Trailing "(0)" or " 0" or " 0 results"
      if (/(?:^|\s)\(?\s*0\s*\)?(?:\s+results?)?$/.test(t)) {
        row.style.display = 'none';
      }
    });
  }
  function init() {
    hideZeros();
    var target = document.querySelector('.facets, .facets-container, #FacetFiltersForm, facet-filters-form') || document.body;
    var mo = new MutationObserver(function () { hideZeros(); });
    mo.observe(target, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
